import bioreqApi from '../../../api/bioreq-documents'

const mapOrder = (order) => {
  switch (order) {
  case 'title':
    return 'title'
  case 'size':
    return 'size'
  default:
    return 'created_at'
  }
}

export default {
  async index({commit, rootState, state}, view) {
    const tenantID = rootState.tenants.current.id
    const meta = state.views[view].meta
    const params = {tenantID}

    if (typeof(meta.processed) !== 'undefined' && meta.processed !== null) {
      params.processed = meta.processed
    }
    if (typeof(meta.order) !== 'undefined' && meta.order !== null) {
      params.order = mapOrder(meta.order)
    }
    if (typeof(meta.desc) !== 'undefined' && meta.desc !== null) {
      params.desc = meta.desc
    }

    // don't set page if search is set
    if (typeof(meta.search) !== 'undefined' && meta.search !== null) {
      params.search = meta.search
    } else if (typeof(meta.current_page) !== 'undefined' && meta.current_page !== null) {
      params.page = meta.current_page
    }

    commit('setFetchingForView', {view, value: true})

    const resp = await bioreqApi.index(params)
    const index = resp.data.data
    const updatedMeta = resp.data.meta

    commit('setView', {view, index, meta: updatedMeta})
    commit('setFetchingForView', {view, value: false})
  },

  async show({commit, rootState}, {id}) {
    const tenantID = rootState.tenants.current.id
    const resp = await bioreqApi.show({tenantID, bioreqID: id})
    commit('setCurrent', resp.data.data)
  },

  async indexByUser({commit, rootState, state}, view) {
    const tenantID = rootState.tenants.current.id
    const meta = state.views[view].meta
    const params = {tenantID}

    if (typeof(meta.processed) !== 'undefined' && meta.processed !== null) {
      params.processed = meta.processed
    }
    if (typeof(meta.order) !== 'undefined' && meta.order !== null) {
      params.order = mapOrder(meta.order)
    }
    if (typeof(meta.desc) !== 'undefined' && meta.desc !== null) {
      params.desc = meta.desc
    }

    // don't set page if search is set
    if (typeof(meta.search) !== 'undefined' && meta.search !== null) {
      params.search = meta.search
    } else if (typeof(meta.current_page) !== 'undefined' && meta.current_page !== null) {
      params.page = meta.current_page
    }

    commit('setFetchingForView', {view, value: true})

    const resp = await bioreqApi.indexByUser(params)
    const index = resp.data.data
    const updatedMeta = resp.data.meta

    commit('setView', {view, index, meta: updatedMeta})
    commit('setFetchingForView', {view, value: false})
  },

  async store({commit, state, dispatch, rootState}) {
    const tenantID = rootState.tenants.current.id

    const formData = new FormData()
    formData.append('title', state.forms.store.fields.title)
    formData.append('description', state.forms.store.fields.description)
    formData.append('file', state.forms.store.fields.file)

    let success = true

    commit('forms/store/resetErrors')
    commit('forms/store/resetSuccess')
    commit('forms/store/setSaving', true)

    try {
      // store the document
      await bioreqApi.store({tenantID, data: formData})

    } catch (err) {      
      success = false

      if (err.response) {
        if (err.response.status === 422 || err.response.status === 406) {
          const errors = err.response.data.errors
          commit('forms/store/setErrors', errors)
        }
      }
    }

    commit('forms/store/setSaving', false)
    commit('forms/store/setSuccess', success)

    if (success) {
      dispatch('index', state._defaultView)
      dispatch('index', state._processedView)
    }
  },

  async match({commit, state, rootState, dispatch}, bioreqID) {
    const tenantID = rootState.tenants.current.id
    const message = state.forms.match.fields.message
    const data = { 'match': true, 'message': message }

    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._processedView, value: true})
    await bioreqApi.match({tenantID, bioreqID, data})
    dispatch('index', state._defaultView)
    dispatch('index', state._processedView)
  },

  async noMatch({commit, state, rootState, dispatch}, bioreqID) {
    const tenantID = rootState.tenants.current.id
    const data = { 'match': false }

    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._processedView, value: true})
    await bioreqApi.match({tenantID, bioreqID, data})
    dispatch('index', state._defaultView)
    dispatch('index', state._processedView)
  },

  async download({commit, state, rootState, dispatch}, bioreqID) {
    const tenantID = rootState.tenants.current.id

    await bioreqApi.download({tenantID, bioreqID})
    dispatch('index', state._defaultView)
    dispatch('index', state._processedView)
  },

  async view({commit, state, rootState, dispatch}, bioreqID) {
    const tenantID = rootState.tenants.current.id

    await bioreqApi.show({tenantID, bioreqID})
  },

  async destroy({commit, state, rootState, dispatch}, bioreqID) {
    const tenantID = rootState.tenants.current.id
    
    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._processedView, value: true})
    await bioreqApi.destroy({tenantID, bioreqID})
    dispatch('index', state._defaultView)
    dispatch('index', state._processedView)

  }
}


// WEBPACK FOOTER //
// ./src/store/modules/bioreq/actions.js